import React, { useRef, useState, useEffect } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Box } from "@mui/material";
import './draggable.css'
const resposive = { display: { xs: 'none', md: 'block' } }
export default function Draggable({ children }) {
    const boxRef = useRef(null);

    const [position, setPosition] = useState({ x: 10, y: 70 });

    const draggingRef = useRef(false);
    const lastRef = useRef({ x: 0, y: 0 });

    // ✅ Clamp inside viewport
    const clamp = (x, y) => {
        const box = boxRef.current;
        if (!box) return { x, y };

        const rect = box.getBoundingClientRect();

        const maxX = window.innerWidth - rect.width;
        const maxY = window.innerHeight - rect.height;

        return {
            x: Math.max(0, Math.min(x, maxX)),
            y: Math.max(0, Math.min(y, maxY)),
        };
    };

    const onMouseMove = (e) => {
        if (!draggingRef.current) return;

        const dx = e.clientX - lastRef.current.x;
        const dy = e.clientY - lastRef.current.y;

        setPosition((prev) => {
            const nextX = prev.x + dx;
            const nextY = prev.y + dy;
            return clamp(nextX, nextY);
        });

        lastRef.current = { x: e.clientX, y: e.clientY };
    };

    const onMouseUp = () => {
        draggingRef.current = false;
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
    };

    const onMouseDown = (e) => {
        draggingRef.current = true;
        lastRef.current = { x: e.clientX, y: e.clientY };

        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
    };

    useEffect(() => {
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, []);

    return (
        <>
            <div
                className="draggable-toolbar"
                ref={boxRef}

                style={{
                    position: "fixed",
                    left: position.x,
                    top: position.y,
                    padding: 24,
                    color: 'inherit',
                    borderRadius: 32,
                    cursor: "grab",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    userSelect: "none",
                    zIndex: 9999,
                    gap: 2
                }}
            >

                <div class="overlay"></div>
                <Box sx={{ ...resposive, ml: -1 }}><BsThreeDotsVertical style={{ color: '#dbb220ff', cursor: 'move', position: 'relative' }} onMouseDown={onMouseDown} fontSize={20} /></Box>

                <Box sx={{ position: 'relative' }}>
                    {children}
                </Box>
            </div>
        </>
    );
}